var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c(
            "avue-crud",
            {
              ref: "crud",
              attrs: {
                page: _vm.page,
                data: _vm.tableData,
                permission: _vm.permissionList,
                "table-loading": _vm.tableLoading,
                option: _vm.tableOption,
              },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "on-load": _vm.getList,
                "search-change": _vm.searchChange,
                "refresh-change": _vm.refreshChange,
                "size-change": _vm.sizeChange,
                "current-change": _vm.currentChange,
                "row-update": _vm.handleUpdate,
                "row-save": _vm.handleSave,
                "row-del": _vm.handleDel,
              },
            },
            [
              _c(
                "template",
                { slot: "menuLeft" },
                [
                  _vm.permissions.sys_post_add
                    ? _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: { type: "primary", icon: "el-icon-edit" },
                          on: {
                            click: function ($event) {
                              return _vm.$refs.crud.rowAdd()
                            },
                          },
                        },
                        [_vm._v("添加\n        ")]
                      )
                    : _vm._e(),
                  _vm.permissions.sys_post_export
                    ? _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: {
                            plain: "",
                            type: "primary",
                            size: "small",
                            icon: "el-icon-upload",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$refs.excelUpload.show()
                            },
                          },
                        },
                        [_vm._v("导入\n        ")]
                      )
                    : _vm._e(),
                  _vm.permissions.sys_post_export
                    ? _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: {
                            plain: "",
                            type: "primary",
                            size: "small",
                            icon: "el-icon-download",
                          },
                          on: { click: _vm.exportExcel },
                        },
                        [_vm._v("导出\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          ),
          _c("excel-upload", {
            ref: "excelUpload",
            attrs: {
              title: "岗位信息导入",
              url: "/admin/post/import",
              "temp-name": "岗位信息.xlsx",
              "temp-url": "/admin/sys-file/local/file/post.xlsx",
            },
            on: { refreshDataList: _vm.handleRefreshChange },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }